export const COLUMN_IDS = {
  TYPE: 'TYPE',
  RECORD_AVAILABILITY: 'RECORD_AVAILABILITY',
}

export const ROW_IDS = {
  OVERDUE_TAX_DEBT: 'overdue_Tax_Debt',
  OVERDUE_SOCIAL_INSURANCE_DEBT: 'overdue_Social_Insurance',
  INVOICE_ENFORMENT: 'invoice_Enforment',
}
